// Add body modifier if mobile sticky ad is visible
const ef_mobileStickyAdContainer = document.querySelector(".ef-mobile-sticky-ad__banner > div");

if (typeof(ef_mobileStickyAdContainer) != "undefined" && ef_mobileStickyAdContainer != null) {

  function checkMobileStickyAd() {
    if (ef_mobileStickyAdContainer.children.length) {
      document.body.classList.add("--mobile-sticky-ad");
    }
  }

  setTimeout(() => checkMobileStickyAd(), 1000);
  setTimeout(() => checkMobileStickyAd(), 2000);
  setTimeout(() => checkMobileStickyAd(), 3000);
  setTimeout(() => checkMobileStickyAd(), 4000);
  setTimeout(() => checkMobileStickyAd(), 5000);
  setTimeout(() => checkMobileStickyAd(), 10000);
}
